export default __webpack_public_path__ + "static/roof_w.2955829197acf67045c37c84424a1011.svg";